import { useQuery } from "@tanstack/react-query";
import { listTokens } from "@/lib/api/tokens";
import type { AccessToken, TokenType } from "@/types/token";

export function useTokens(type?: TokenType) {
  return useQuery<AccessToken[], Error>({
    queryKey: type ? ["tokens", type] : ["tokens"],
    queryFn: () => listTokens(type),
  });
}
